<!-- eslint-disable vue/no-deprecated-v-bind-sync -->
<template>
    <vue-scroll class="page-articles" v-if="form.articles">
        <div class="articles-container">
            <el-tabs
                ref="tabs"
                class="tabs-articles"
                v-model="activeTab"
                tab-position="left"
                @tab-click="onTabClick"
            >
                <el-tab-pane
                    v-for="(article, index) in form.articles"
                    :key="index"
                    :label="index ? 'Article ' + (index + 1) : 'Cover Article'"
                    :name="'tab-' + index"
                >
                    <div
                        class="article-card"
                        v-if="activeTab === 'tab-' + index"
                    >
                        <h3 class="card-title">
                            {{
                                index
                                    ? "Article " + (index + 1)
                                    : "Cover Article"
                            }}
                        </h3>

                        <el-form>
                            <el-alert
                                :closable="false"
                                :title="`The newsletter may not have more than ${maxUploads} photos.`"
                                show-icon
                                type="error"
                                v-if="exceedsMaxUploads"
                            >
                            </el-alert>
                            <el-form-item
                                :class="articleForm.state('headline')"
                                :label="
                                    index
                                        ? `Article ${index + 1} - Headline`
                                        : 'Cover Article - Headline'
                                "
                            >
                                <el-checkbox
                                    v-if="!index"
                                    class="ml-10"
                                    v-model="form.filler_as_cover"
                                    @change="
                                        handleChangeFillerForCover(
                                            articleForm,
                                            article
                                        )
                                    "
                                    >Use Filler Article for Cover</el-checkbox
                                >
                                <el-input
                                    @input="handleHeadlineInput"
                                    name="headline"
                                    :key="'headline-' + index"
                                    v-model="articleForm.headline"
                                    v-validate="'max:255'"
                                    :disabled="form.filler_as_cover && !index"
                                />
                                <form-feedback
                                    :form="articleForm"
                                    field="headline"
                                />
                            </el-form-item>

                            <el-form-item
                                class="mb-0"
                                :label="
                                    index
                                        ? `Article ${index + 1} - Body Text`
                                        : 'Cover Article - Body Text'
                                "
                            >
                            </el-form-item>

                            <div
                                :class="{
                                    'is-error':
                                        form.errors.has(
                                            `articles.${activeTabIndex}.body`
                                        ) || articleForm.errors.has('body')
                                }"
                                class="quill-editor"
                            >
                                <div
                                    id="toolbar"
                                    v-show="!form.filler_as_cover || index > 0"
                                >
                                    <!-- <div class="d-inline-block">
                                <a class="text" @click="stack()">stack</a>
                            </div> -->
                                    <div class="d-inline-block ml-2">
                                        <el-button
                                            @click.prevent="undo()"
                                            class="undo"
                                            title="Undo"
                                            type="primary"
                                            plain
                                        >
                                            <svg viewbox="0 0 18 18">
                                                <polygon
                                                    class="ql-fill ql-stroke"
                                                    points="6 10 4 12 2 10 6 10"
                                                />
                                                <path
                                                    class="ql-stroke"
                                                    d="M8.09,13.91A4.6,4.6,0,0,0,9,14,5,5,0,1,0,4,9"
                                                />
                                            </svg>
                                        </el-button>
                                        <a class="text" @click="undo()">Undo</a>
                                    </div>
                                    <div class="d-inline-block ml-2">
                                        <el-button
                                            @click.prevent="redo()"
                                            class="redo"
                                            title="Redo"
                                            type="primary"
                                            plain
                                        >
                                            <svg viewbox="0 0 18 18">
                                                <polygon
                                                    class="ql-fill ql-stroke"
                                                    points="12 10 14 12 16 10 12 10"
                                                />
                                                <path
                                                    class="ql-stroke"
                                                    d="M9.91,13.91A4.6,4.6,0,0,1,9,14a5,5,0,1,1,5-5"
                                                />
                                            </svg>
                                        </el-button>
                                        <a class="text" @click="redo()">Redo</a>
                                    </div>
                                    <div class="d-inline-block ml-2">
                                        <el-button
                                            title="Add Photo"
                                            class="ql-image"
                                            @click="uploadDialogVisible = true"
                                        />
                                        <a
                                            class="text"
                                            @click="uploadDialogVisible = true"
                                            >Add Photo</a
                                        >
                                    </div>
                                    <div class="d-inline-block ml-2">
                                        <button
                                            class="ql-check"
                                            title="Check Spelling and Grammar"
                                            @click="checkspelling()"
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 576 512"
                                            >
                                                <path
                                                    fill="#ff6a6a"
                                                    d="M112 0C99.1 0 87.4 7.8 82.5 19.7l-66.7 160-13.3 32c-6.8 16.3 .9 35 17.2 41.8s35-.9 41.8-17.2L66.7 224l90.7 0 5.1 12.3c6.8 16.3 25.5 24 41.8 17.2s24-25.5 17.2-41.8l-13.3-32-66.7-160C136.6 7.8 124.9 0 112 0zm18.7 160l-37.3 0L112 115.2 130.7 160zM256 32l0 96 0 96c0 17.7 14.3 32 32 32l80 0c44.2 0 80-35.8 80-80c0-23.1-9.8-43.8-25.4-58.4c6-11.2 9.4-24 9.4-37.6c0-44.2-35.8-80-80-80L288 0c-17.7 0-32 14.3-32 32zm96 64l-32 0 0-32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16zm-32 64l32 0 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0-32zM566.6 310.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L352 434.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l192-192z"
                                                />
                                            </svg>
                                        </button>
                                        <a class="text" @click="checkspelling()"
                                            >Check Spelling and Grammar</a
                                        >
                                    </div>
                                    <div class="d-inline-block ml-2">
                                        <button
                                            class="ql-check"
                                            @click="clearResults()"
                                            title="Clear Spell Check Results"
                                        >
                                            <svg
                                                fill="#000000"
                                                viewBox="0 0 32 32"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    fill="#ff6a6a"
                                                    d="M7.004 23.087l7.08-7.081-7.07-7.071L8.929 7.02l7.067 7.069L23.084 7l1.912 1.913-7.089 7.093 7.075 7.077-1.912 1.913-7.074-7.073L8.917 25z"
                                                />
                                            </svg>
                                        </button>
                                        <a class="text" @click="clearResults()"
                                            >Clear Spell Check Results</a
                                        >
                                    </div>
                                    <div class="d-inline-block float-right">
                                        <el-checkbox
                                            v-model="autoCheckSpelling"
                                            @change="setAutoCheckSpelling"
                                            class="text"
                                            >Auto Spell Check</el-checkbox
                                        >
                                    </div>
                                </div>
                                <div
                                    id="editor"
                                    ondragstart="return false;"
                                    ondrop="return false;"
                                ></div>
                            </div>

                            <p
                                class="danger-text"
                                v-if="
                                    (activeArticle &&
                                        form.errors.has(
                                            `articles.${activeTabIndex}.body`
                                        )) ||
                                    articleForm.errors.has('body')
                                "
                            >
                                <span v-if="articleForm.errors.has('body')">
                                    {{ articleForm.errors.get("body") }}
                                </span>
                                <span v-else>
                                    {{
                                        form.errors.get(
                                            `articles.${activeTabIndex}.body`
                                        )
                                    }}
                                </span>
                            </p>

                            <p class="text-error text-tiny">
                                * You cannot copy and paste the image from
                                another website. You can only upload images from
                                your computer using the upload button. Images
                                you find on the web are copyrighted and stolen
                                if you paste them in. Corwin is not responsible
                                for stolen content supplied by you, as we assume
                                you have permission to use what you submit to
                                us.
                            </p>

                            <div class="float-right">
                                <el-button
                                    type="danger"
                                    round
                                    size="small"
                                    icon="mdi mdi-delete"
                                    @click="deleteArticle(article, index)"
                                    >Delete Article
                                </el-button>
                                <el-button
                                    type="primary"
                                    round
                                    size="small"
                                    :loading="form.busy"
                                    icon="mdi mdi-content-save"
                                    @click="save()"
                                    >Save and Proceed
                                </el-button>
                            </div>
                            <div class="clearfix"></div>
                        </el-form>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>

        <el-dialog
            title="Upload Image"
            :visible.sync="uploadDialogVisible"
            :close-on-click-modal="false"
            width="400px"
        >
            <el-upload
                accept="image/png,image/jpeg,image/gif"
                ref="imageUploader"
                class="upload-demo"
                :limit="remainingUploads"
                action="/web-api/upload"
                :data="{ for: UploadFor.newsletterArticleImage }"
                :auto-upload="true"
                :on-exceed="onExceedMaxUploads"
                :headers="{
                    'X-Requested-With': 'XMLHttpRequest',
                    'X-CSRF-TOKEN': csrf
                }"
                :with-credentials="true"
                :on-success="onSuccessUpload"
                :before-upload="onBeforeUpload"
                :on-remove="onRemoveFile"
                list-type="picture"
                :on-error="onErrorUpload"
                :multiple="true"
            >
                <el-button size="small" type="primary"
                    >Click to upload</el-button
                >
            </el-upload>
            <template v-slot:footer>
                <div class="dialog-footer">
                    <el-button @click="uploadDialogVisible = false"
                        >Cancel</el-button
                    >
                    <el-button
                        :disabled="!current_uploads.length || uploading"
                        @click="insertImage()"
                        icon="mdi mdi-image-plus"
                        type="primary"
                    >
                        Insert
                    </el-button>
                </div>
            </template>
        </el-dialog>
    </vue-scroll>
</template>

<script>
import UploadFor from "@/constants/upload-for";
import ImageBlot from "@/plugins/quill";
import QuillHistory from "@/plugins/quill-history";
import {
    getCleanedHtml,
    default as registerQuillLanguageTool
} from "@/plugins/quill-languagetool/index.es";
import FileUtils from "@/utils/file";
import _Quill from "quill";
const Quill = window.Quill || _Quill;
const Delta = Quill.import("delta");

export default {
    props: {
        newsletter: {
            required: true,
            type: Object
        },
        form: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            UploadFor,
            activeTab: "tab-0",
            uploadDialogVisible: false,
            uploads: [],
            uploading: false,
            current_uploads: [],
            current_upload_files: [],
            editor: null,
            articleForm: new Form({
                headline: null,
                body: null
            }),
            autoCheckSpelling: true
        };
    },
    mounted() {
        Vue.nextTick(() => {
            this.articleForm.setVeeErrors(this.veeErrors);
            this.initEditor();
            this.initAddArticleButton();
            this.initArticleForm();
            this.autoCheckSpelling =
                this.$cookies.get("autoCheckSpelling") !== "false";
        });
    },
    watch: {
        activeArticle() {
            if (!this.activeArticle) {
                return;
            }
            this.articleForm.headline = this.activeArticle.headline;
            this.validateBody();
        }
    },
    computed: {
        activeTabIndex() {
            return parseInt(this.activeTab.split("-")[1]);
        },
        csrf() {
            return this.$store.state.csrf;
        },
        activeArticle() {
            return this.form.articles[this.activeTabIndex];
        },
        hasValidationErrors() {
            return (
                this.articleForm.errors.has("body") ||
                this.articleForm.errors.has("headline") ||
                this.exceedsMaxUploads
            );
        },
        maxUploads() {
            return this.$store.state.config.settings.newsletter.max_photos;
        },
        uploadCount() {
            return _.sumBy(
                this.form.articles,
                (article) => article.uploads.length
            );
        },
        canUploadMorePhotos() {
            return this.uploadCount < this.maxUploads;
        },
        remainingUploads() {
            return this.maxUploads - this.uploadCount;
        },
        exceedsMaxUploads() {
            return this.uploadCount > this.maxUploads;
        }
    },
    methods: {
        initArticleForm() {
            if (!this.activeArticle) {
                return;
            }
            this.articleForm.headline = this.activeArticle.headline;
            this.articleForm.body = this.activeArticle.body;
        },
        initAddArticleButton() {
            let button = $(
                `<button type="button" class="mt-5 el-button el-button--primary el-button--small is-round"><i class="mdi mdi-plus"></i><span>Add Article</span></button>`
            );
            $(this.$refs.tabs.$el).find(".el-tabs__header").append(button);
            button.click(() => {
                this.addArticle();
            });
        },
        onTabClick(tab) {
            this.initEditor();
            this.closePopup();
        },
        warnMaxUploadsReached() {
            this.$alert(
                `The newsletter may not have more than ${this.maxUploads} photos.`,
                "Oops!",
                {
                    confirmButtonText: "OK"
                }
            );
        },
        initEditor() {
            let self = this;
            this.$validator.pause();
            Vue.nextTick(() => {
                ImageBlot.blotName = "image";
                ImageBlot.tagName = "img";
                Quill.register(ImageBlot);
                Quill.register("modules/history", QuillHistory, true);
                registerQuillLanguageTool(Quill);
                this.editor = new Quill("#editor", {
                    debug: "warn",
                    formats: ["image", "ltmatch"],
                    modules: {
                        toolbar: {
                            container: "#toolbar",
                            handlers: {
                                image() {
                                    if (!self.canUploadMorePhotos) {
                                        self.warnMaxUploadsReached();
                                        return;
                                    }
                                    if (
                                        self.activeTab == "tab-0" &&
                                        self.form.filler_as_cover
                                    ) {
                                        self.uploadDialogVisible = false;
                                    } else {
                                        self.uploadDialogVisible = true;
                                    }
                                }
                            }
                        },
                        history: {
                            delay: 2000,
                            maxStack: 500,
                            userOnly: true
                        },
                        languageTool: {
                            server: process.env.MIX_LANGUAGETOOL_SERVER_URL,
                            cooldownTime:
                                process.env.MIX_LANGUAGETOOL_COOLDOWNTIME,
                            autoCheckSpelling: this.autoCheckSpelling,
                            apiOptions: {
                                level: "default",
                                language: "auto",
                                preferredVariants: "en-US"
                            }
                        },
                        clipboard: {
                            matchers: [
                                [
                                    Node.ELEMENT_NODE,
                                    function (node, delta) {
                                        var plaintext = $(node).text();
                                        var result = new Delta().insert(
                                            plaintext
                                        );
                                        return result;
                                    }
                                ]
                            ]
                        }
                    },
                    placeholder: "Enter article body here...",
                    readOnly:
                        self.activeTab == "tab-0" && self.form.filler_as_cover
                            ? true
                            : false,
                    theme: "snow"
                });
                this.editor.root.innerHTML = getCleanedHtml(
                    this.activeArticle.body
                );
                // Use lodash debounce for simpler implementation
                const debouncedSave = _.debounce(() => {
                    this.saveArticleDetails();
                }, 300);

                const debouncedValidate = _.debounce(() => {
                    this.validateBody();
                }, 150);

                this.editor.on("text-change", (delta, oldDelta, source) => {
                    this.activeArticle.body = getCleanedHtml(
                        this.editor.root.innerHTML
                    );

                    let has_delete = false;
                    _.forEach(delta.ops, (op) => {
                        if (op["delete"]) {
                            has_delete = true;
                            return false;
                        }
                    });

                    if (has_delete) {
                        debouncedSave();
                    }
                    debouncedValidate();
                });
                this.editor.on("selection-change", (range) => {
                    if (!range) {
                        debouncedSave();
                    }
                });
                this.$validator.resume();
            });
        },
        onExceedMaxUploads(files, fileList) {
            this.warnMaxUploadsReached();
        },
        handleHeadlineInput(val) {
            if (this.activeArticle) {
                Vue.set(this.activeArticle, "headline", val);
            }
            this.$emit("typing-activity");
        },
        onChangeHeadline(val) {
            if (this.activeArticle) {
                Vue.set(this.activeArticle, "headline", val);
            }
        },
        onInput() {
            this.$emit("typing-activity");
        },
        validateBody() {
            if (!this.activeArticle) {
                return;
            }
            this.articleForm.errors.remove("body");
            if ($(this.activeArticle.body).text().length > 11000) {
                this.articleForm.errors.add(
                    "body",
                    "The article body may not be greater than 11000 characters."
                );
            }
        },
        saveArticleDetails() {
            let new_uploads = [];
            _.forEach(this.editor.getContents().ops, (op) => {
                if (op.insert["image"]) {
                    let upload_id = op.insert.image.data.upload_id;
                    let upload = this.activeArticle.uploads.find(
                        (item) => item.id === upload_id
                    );
                    if (!upload) {
                        upload = this.uploads.find(
                            (item) => item.id === upload_id
                        );
                    }
                    if (upload) {
                        new_uploads.push(_.pick(upload, ["id", "url"]));
                    }
                }
            });
            this.activeArticle.uploads = new_uploads;
        },
        addArticle() {
            this.form.articles.push({
                id: null,
                newsletter_id: this.newsletter.id,
                headline: null,
                body: "",
                is_recurring: false,
                uploads: []
            });
            this.activeTab = "tab-" + (this.form.articles.length - 1);
            this.initEditor();
        },
        deleteArticle(article, index) {
            if (index) {
                this.$confirm(
                    _.isEmpty(_.trim(article.headline))
                        ? `Are you sure you want to delete this unnamed article?`
                        : `Are you sure you want to delete article ${article.headline}?`,
                    "Confirmation",
                    {
                        confirmButtonText: "Delete Article",
                        confirmButtonClass: "el-button--danger",
                        cancelButtonText: "Cancel",
                        type: "warning"
                    }
                )
                    .then(() => {
                        window.Utils.arrayDelete(this.form.articles, article);
                    })
                    .catch(() => {
                        //user cancelled
                    });
            } else {
                this.$notify.error({
                    message: "You can not delete cover article."
                });
            }
        },
        onSuccessUpload(response, file, fileList) {
            this.current_uploads.push(response);
            this.current_upload_files.push(file);
            this.uploads.push(response);
            if (this.current_uploads.length === fileList.length) {
                this.uploading = false;
            }
        },
        onBeforeUpload(file) {
            var ext = file.name.split(".").pop();
            if (
                ["doc", "docx", "heic"]
                    .map((i) => {
                        return i.toLowerCase();
                    })
                    .includes(ext.toLowerCase())
            ) {
                this.$message.error("This format is not supported.");
                return false;
            } else {
                return FileUtils.checkFileSize(file).then(() => {
                    this.uploading = true;
                });
            }
        },
        onRemoveFile(file) {
            if (file.status == "success") {
                let index = _.indexOf(this.current_upload_files, file);
                this.current_uploads.splice(index, 1);
                this.current_upload_files.splice(index, 1);
            } else {
                this.uploading = false;
            }
        },
        insertImage() {
            this.current_uploads.forEach((upload) => {
                let index = _.get(this.editor.getSelection(true), "index");
                if (index === null) {
                    index = this.editor.getLength();
                }
                this.editor.insertEmbed(index, "image", {
                    attributes: {
                        src: upload.url,
                        width: 500,
                        alt: "(Image Preview Unavailable)",
                        url: upload.url
                    },
                    data: {
                        upload_id: upload.id
                    }
                });
            });
            this.current_uploads = [];
            this.current_upload_files = [];
            this.$refs.imageUploader.clearFiles();
            this.uploadDialogVisible = false;
            this.saveArticleDetails();
        },
        save() {
            this.form.articles.forEach((article) => {
                article.body = getCleanedHtml(article.body);
                article.body = this.removeNonBreakingSpaces(article.body);
            });

            this.$emit("save");
            this.closePopup();
        },
        removeNonBreakingSpaces(html) {
            return html.replace(/&nbsp;/g, " ");
        },
        handleChangeFillerForCover(articleForm, article) {
            if (
                document
                    .querySelector("div[id=editor]")
                    .classList.contains("ql-disabled")
            ) {
                document.querySelector("div[id=editor]").className =
                    "ql-container ql-snow";
            }
            if (this.form.filler_as_cover) {
                this.$confirm(
                    "Checking this box will delete all text in the Cover Article space. Corwin will place our filler article on the cover instead of your content. Do you wish to proceed?",
                    "Confirmation",
                    {
                        confirmButtonText: "OK",
                        cancelButtonText: "Cancel",
                        type: "warning"
                    }
                )
                    .then(() => {
                        article.headline = null;
                        articleForm.headline = null;
                        article.body = "";
                        article.uploads = [];
                        this.initEditor();
                    })
                    .catch(() => {
                        this.form.filler_as_cover = false;
                        this.initEditor();
                    });
            } else {
                this.initEditor();
            }
        },
        onErrorUpload(err, file, fileList) {
            this.$message.error(err.message);
            this.uploading = false;
        },
        checkspelling() {
            this.closePopup();
            this.editor.getModule("languageTool").checkSpelling();
        },
        closePopup() {
            this.editor.getModule("languageTool").popups.closePopup();
        },
        undo() {
            this.editor.history.undo();
        },
        redo() {
            this.editor.history.redo();
        },
        stack() {},
        setAutoCheckSpelling() {
            this.$cookies.set("autoCheckSpelling", this.autoCheckSpelling);
            this.editor
                .getModule("languageTool")
                .setAutoCheckSpelling(this.autoCheckSpelling);
        },
        clearResults() {
            this.activeArticle.body = getCleanedHtml(
                this.editor.root.innerHTML
            );
            this.editor.root.innerHTML = this.activeArticle.body;
        }
    }
};
</script>

<style lang="scss" scoped>
.articles-container {
    max-width: 1800px;
    margin: 0;
    padding-left: 20px;
}

.article-card {
    background-color: #f9f9f9;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    padding: 20px;
    border: 1px solid #eaeaea;
    margin-bottom: 20px;
}

.card-title {
    margin-bottom: 20px;
    padding-left: 5px;
    color: #333;
    font-size: 18px;
    border-bottom: 1px solid #e0e0e0;
    padding-bottom: 10px;
}

:deep(.el-tabs__item) {
    height: 50px;
    line-height: 50px;
    color: #333;
}

:deep(.el-tabs__item.is-active) {
    color: #ffffff;
    font-weight: bold;
}

:deep(.el-tabs__nav) {
    background-color: #f9f9f9;
    border-radius: 8px 0 0 8px;
    border: 1px solid #eaeaea;
    border-right: none;
}

.quill-editor {
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    margin-bottom: 20px;
}

:deep(.ql-toolbar) {
    border-bottom: 1px solid #dcdfe6;
    background-color: #f5f7fa;
    border-radius: 4px 4px 0 0;
}

:deep(.ql-container) {
    border: none;
    min-height: 250px;
}

.danger-text {
    color: #F56C6C;
    font-size: 14px;
    margin-top: 5px;
}

:deep(.el-form-item__label) {
    color: #606266;
    font-weight: bold;
}

:deep(.el-input__inner) {
    width: 100%;
}

.text-error {
    color: #F56C6C;
}

.text-tiny {
    font-size: 12px;
    margin-top: 10px;
    margin-bottom: 20px;
}

@media (max-width: 991px) {
    :deep(.el-tabs--left) {
        flex-direction: column;
    }
    
    :deep(.el-tabs__header.is-left) {
        margin-right: 0;
        margin-bottom: 15px;
    }
    
    :deep(.el-tabs__nav-wrap.is-left) {
        margin-bottom: 15px;
    }
    
    :deep(.el-tabs__nav.is-left) {
        border-radius: 8px 8px 0 0;
        border-right: 1px solid #eaeaea;
        border-bottom: none;
    }
    
    :deep(.el-tabs__item) {
        height: 40px;
        line-height: 40px;
    }
}
</style>
